import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CoreSidebarService} from '@core/components/core-sidebar/core-sidebar.service';
import {ProductService} from '../../shared/services/product.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CartService} from '../../shared/services/cart.service';
import {DataService} from '../../shared/services/data.service';
import {StockistService} from '../../shared/services/stockist.service';
import {AlertService} from '../../shared/services/alert.service';
import {AppConstants} from '../../shared/constants/app-constant';
import {createLogErrorHandler} from '@angular/compiler-cli/ngcc/src/execution/tasks/completion';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {
    showSearch = false;
    searchForm: FormGroup;
    stockistFilterForm: FormGroup;
    submitting: any = false;
    notSameStockist: any = false;
    modalType: any;
    checkStockist: any;
    stockists: any = [];
    products: any = [];
    cartProducts: any = [];
    selectedProduct: any;
    imageBaseUrl: any = AppConstants.BUCKET_URL;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private productService: ProductService,
                private stockistService: StockistService,
                public alertService: AlertService,
                private dataService: DataService,
                private cartService: CartService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'username': [''],
            'email': [''],
            'contact': [''],
        });
        this.stockistFilterForm = this.fb.group({
            'stockist_id': ['']
        });
        this.getStockists();
    }

    getStockists() {
        this.stockists = [];
        this.stockistService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.stockists = data['data'];
            } else {
                this.stockists = [];
            }
        });
    }

    get(params: any = {}) {
        this.products = [];
        if (this.stockistFilterForm.value.stockist_id) {
            params.page = -1;
            params.type = 'PRODUCT';
            params.section = 'PRODUCT_LIST';
            this.submitting = true;
            this.stockistService.detailByUNniqueId(this.stockistFilterForm.value.stockist_id).subscribe(dt => {
                this.checkStockist = dt.user_id;
            });
            this.productService.getStockistProduct(this.stockistFilterForm.value.stockist_id, params).subscribe(data => {
                if (data && data['data'].length > 0) {
                    this.products = data['data'];
                    this.getCartProducts();
                } else {
                    this.products = [];
                }
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        }

    }

    getCartProducts() {
        this.cartService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.cartProducts = data['data'];
                this.mapCartWithProducts();
            } else {
                this.cartProducts = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    mapCartWithProducts() {
        let cartProducts = this.cartProducts;
        this.products.forEach(product => {
            cartProducts.forEach(cartProduct => {
                if ((parseInt(product.product_id) === parseInt(cartProduct.product_id)) && (cartProduct.stockist_id == this.checkStockist)) {
                    product['added_to_cart'] = true;
                }
            });
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }

    viewProductDetail(content, data) {
        this.selectedProduct = data;
        this.modalType = 'PRODUCT_DETAILS';
        this.modalService.open(content, {'size': 'lg'});
    }

    addToCart(content, product) {
        if (this.stockists && this.stockists.length > 0) {
            let stockistId: any;
            this.stockists.forEach(stockist => {
                if (stockist && stockist['unique_id'] == this.stockistFilterForm.value.stockist_id) {
                    stockistId = stockist.user_id;
                }
            });
            let params = {};
            this.cartService.get(params).subscribe(dd => {
                if (dd && dd['data'].length > 0) {
                    dd['data'].forEach(items => {
                        if (items.stockist_id != stockistId) {
                            this.modalType = 'CART_CONFORMATION';
                            this.modalService.open(content, {size: 'md'});
                            this.notSameStockist = true;
                        } else {
                            this.notSameStockist = false;
                        }
                    });
                    if (!this.notSameStockist) {
                        this.cartService.add({
                            'stockist_id': stockistId,
                            'product_id': product.product.id,
                            'quantity': 1
                        }).subscribe(data => {
                            product['added_to_cart'] = !(product && product['added_to_cart']);
                            this.dataService.sendMessage('GET_CART_ITEMS');
                        }, error => {
                            this.submitting = false;
                        });
                    }
                } else {
                    this.cartService.add({
                        'stockist_id': stockistId,
                        'product_id': product.product.id,
                        'quantity': 1
                    }).subscribe(data => {
                        product['added_to_cart'] = !(product && product['added_to_cart']);
                        this.dataService.sendMessage('GET_CART_ITEMS');
                    }, error => {
                        this.submitting = false;
                    });
                }
            }, error => {
                this.alertService.showErrors('Something went wrong, please try again');
            });
        } else {
            this.alertService.showErrors('Stockist not found');
        }
    }


    clearCartItem() {
        this.cartService.deleteAll().subscribe(data => {
            this.alertService.showSuccess({title: 'Success', message: 'cart Item Removed Successfully'});
            this.modalService.dismissAll('');
            this.dataService.sendMessage('GET_CART_ITEMS');
        });
    }


    removeFromCart(product) {
        this.cartService.delete(product.product.id).subscribe(data => {
            product['added_to_cart'] = !(product && product['added_to_cart']);
            this.dataService.sendMessage('GET_CART_ITEMS');
        }, error => {
            this.submitting = false;
        });
    }
}
